var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prize-card"},[_c('pageTitle',{attrs:{"pageTitle":"抽奖"}},[_c('span',{staticClass:"notice"},[_vm._v(" 同一手机号/邮箱通过不同终端参会可能会出现多条中奖，建议联系售后人员配置用户的单点参会功能 ")])]),_c('div',{staticClass:"prize-info"},[_c('prize-list',{attrs:{"source":'0',"roomId":_vm.roomId}})],1),_c('begin-play',{attrs:{"webinarId":_vm.$route.params.str}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }